export default {
  "mainVegetable": "legume",
  "mainVegetable/01": "legume/vinete",
  "mainVegetable/02": "legume/sparanghel",
  "mainVegetable/03": "legume/avocado",
  "mainVegetable/04": "legume/sfecla",
  "mainVegetable/05": "legume/broccoli",
  "mainVegetable/06": "legume/morcovi",
  "mainVegetable/07": "legume/telina",
  "mainVegetable/08": "legume/ciuperci",
  "mainVegetable/09": "legume/varza",
  "mainVegetable/10": "legume/varza-de-Bruxelles",
  "mainVegetable/11": "legume/varza-chinezeasca",
  "mainVegetable/12": "legume/conopida",
  "mainVegetable/13": "legume/salata-de-varza",
  "mainVegetable/14": "legume/castravete",
  "mainVegetable/15": "legume/dovlecel",
  "mainVegetable/16": "legume/cicoare",
  "mainVegetable/17": "legume/spanac",
  "mainVegetable/18": "legume/fasole-Fava",
  "mainVegetable/19": "legume/flageoleti",
  "mainVegetable/20": "legume/fasole-plata",
  "mainVegetable/21": "legume/fasole-uscata",
  "mainVegetable/22": "legume/fasole-verde",
  "mainVegetable/23": "legume/linte",
  "mainVegetable/24": "legume/salata-de-legume",
  "mainVegetable/25": "legume/porumb",
  "mainVegetable/26": "legume/mesclun",
  "mainVegetable/27": "legume/napi",
  "mainVegetable/28": "legume/ceapa",
  "mainVegetable/29": "legume/mazare-soia",
  "mainVegetable/30": "legume/ardei",
  "mainVegetable/31": "legume/cartofi",
  "mainVegetable/32": "legume/muguri-de-soia",
  "mainVegetable/33": "legume/ridichi",
  "mainVegetable/34": "legume/salata-frunze-de-stejar",
  "mainVegetable/35": "legume/frisee-salata",
  "mainVegetable/36": "legume/salata-iceberg",
  "mainVegetable/37": "legume/salata-piemontez",
  "mainVegetable/38": "legume/salata-de-orez",
  "mainVegetable/39": "legume/salata-romana",
  "mainVegetable/40": "legume/lastari-tineri",
  "mainVegetable/41": "legume/salata-verde",
  "mainVegetable/42": "legume/muguri-de-salata-verde",
  "mainVegetable/43": "legume/rucola",
  "mainVegetable/44": "legume/salsifi",
  "mainVegetable/45": "legume/tabouleh",
  "mainVegetable/46": "legume/rosii",
  "mainVegetable/47": "legume/fasole-galbena",
  "mainVegetable/48": "legume/naut",
  "mainVegetable/49": "legume/praz",
  "mainVegetable/50": "legume/dovleac",
  "mainVegetable/51": "legume/fasole-rosie",
  "mainVegetable/52": "legume/mere",
  "mainVegetable/53": "legume/castane",
  "mainVegetable/54": "legume/prune-confiate",
  "mainVegetable/55": "legume/de-gradina",
  "mainVegetable/56": "legume/masline-negre",
  "mainVegetable/57": "legume/anghinare",
  "mainVegetable/58": "legume/ardei-rosii",
  "mainVegetable/59": "legume/fasole-verde-plata",
  "mainVegetable/60": "legume/primavara",
  "mainVegetable/61": "legume/ratatouille",
  "mainVegetable/62": "legume/couscous",
  "mainVegetable/63": "legume/tagine",
  "mainVegetable/64": "legume/curry-legume",
  "mainVegetable/65": "legume/boabe-de-mazare",
  "mainVegetable/66": "legume",
  "mainVegetable/67": "legume/linte-portocalie",
  "mainVegetable/68": "legume/quinoa",
  "mainVegetable/69": "legume/spelt",
  "mainVegetable/70": "legume/bulgur",
  "mainVegetable/71": "legume/varza-rosie",
  "mainVegetable/72": "legume/varza-kale",
  "mainVegetable/73": "legume/patrunjel",
  "mainVegetable/74": "legume/cereale-si-seminte",
  "mainVegetable/75": "legume/legume",
  "mainVegetable/76": "legume/cartof-dulce",
  "mainVegetable/77": "legume/dovleac-dulce",
  "mainVegetable/78": "legume/aluat",
  "mainVegetable/79": "legume/fasole",
  "mainVegetable/80": "legume/mazare-morcovi",
  "mainVegetable/81": "legume/mazare",
  "mainVegetable/82": "legume/edamame",
  "mainVegetable/83": "legume/orz",
  "mainVegetable/84": "legume/mix-de-salata",
  "mainVegetable/85": "legume/zahar-paine-cicoare",
  "mainVegetable/86": "legume/lamb-lettuce",
  "mainVegetable/87": "legume/baby-spanac",
  "mainVegetable/88": "legume/baby-salata-verde",
  "mainVegetable/89": "legume/salata-rosie",
  "mainVegetable/90": "legume/pastarnac",
  "mainVegetable/91": "legume/orez-negrui",
  "mainVegetable/92": "legume/mix-de-fasole",
  "mainVegetable/93": "legume/fasole-neagra",
  "mainVegetable/94": "legume/varza-patata",
  "mainVegetable/95": "legume/fasole-alba",
  "mainVegetable/96": "legume/rosii-uscate",
  "mainVegetable/97": "legume/mix-de-legume",
  "mainVegetable/98": "legume/butternut",
  "productRange": "game",
  "productRange/4G_BIO": "game",
  "productRange/4G_SRP": "game",
  "productRange/CAN_A_POEL": "game",
  "productRange/CAN_SEC_BI": "game",
  "productRange/CAN_SEC_CO": "game",
  "productRange/CAN_SEC_CU": "game",
  "productRange/CAN_SEC_NA": "game",
  "productRange/CAN_VAPEUR": "game",
  "productRange/CAN_VEG_SA": "game",
  "productRange/CAN_VEG_SR": "game",
  "productRange/CLASSICVEG": "game",
  "productRange/COLDVEGE": "game",
  "productRange/COOKMUSH": "game",
  "productRange/CRUDITES": "game",
  "productRange/DE_NOS_PRO": "game",
  "productRange/DOYMUSHACC": "game",
  "productRange/DOYMUSHAPE": "game",
  "productRange/DRYVEGE": "game",
  "productRange/FROZENVEGE": "game",
  "productRange/FRZ_ASTUCE": "game",
  "productRange/FRZ_GRATIN": "game",
  "productRange/FRZ_KELLO": "game",
  "productRange/FRZ_LEG_CO": "game",
  "productRange/FRZ_PUREES": "game",
  "productRange/FRZ_VEG_BI": "game",
  "productRange/FRZ_VEG_SR": "game",
  "productRange/INDFROZVEG": "game",
  "productRange/JEUNES_POU": "game",
  "productRange/LAITUES": "game",
  "productRange/LOOP": "game",
  "productRange/LUNCH_BOWL": "game",
  "productRange/MACHE_BASE": "game",
  "productRange/MEL_LAITUE": "game",
  "productRange/MUSHNATEMI": "game",
  "productRange/MUSHNATENT": "game",
  "productRange/MUSHNATEPA": "game",
  "productRange/MUSHNATMIN": "game",
  "productRange/MUSHROOMS": "game",
  "productRange/SUNVEGE": "game",
  "productRange/TRAIT_CRUD": "game",
  "productRange/TRAIT_TABO": "game",
  "productRange/TUS_RECETA": "game",
  "productRange/WORLDVEGE": "game",
  "productRange/PREPARED_VEG": "game",
  "productRange/BEAN_SAUCE": "game/fasole-in-sos",
  "productRange/BEANS": "game/fasole",
  "productRange/BIO": "game/bio",
  "productRange/BOND_KIDS": "game/-",
  "productRange/CAN_BIO": "game/-",
  "productRange/CAN_SEC_PR": "game/-",
  "productRange/CARTA_DELL": "game/-",
  "productRange/CAN_PETITS": "game/mic-ambiental",
  "productRange/CAN_BOCAL": "game/borcan-ambiental",
  "productRange/CEREAL_CAN": "game/cereali-ambiental",
  "productRange/CEREAL_FRZ": "game/cereali-congelat",
  "productRange/CEREALI": "game/cereali",
  "productRange/CEREALLEGR": "game/-",
  "productRange/COCCOLE": "game/-",
  "productRange/CORN": "game/porumb",
  "productRange/CREATIF": "game/-",
  "productRange/FRANCAIS": "game/-",
  "productRange/FRZ_FRY_MI": "game/-",
  "productRange/FRZ_MELANG": "game/amestecuri-congelate",
  "productRange/FRZ_POELEE": "game/mixuri-congelate",
  "productRange/INSALATE_D": "game/-",
  "productRange/INSALATONA": "game/-",
  "productRange/LE_REGIONA": "game/-",
  "productRange/LEGUMIO": "game/legumio",
  "productRange/MIXES_CORN": "game/amestecuri-cu-porumb",
  "productRange/MONO_VEGE": "game/monolegume",
  "productRange/MUSHROOMS  ": "game/ciuperci",
  "productRange/NATURA_IN": "game/-",
  "productRange/OTHER_VEG": "game/legume-gata-pregatite",
  "productRange/PEAS": "game/mazare",
  "productRange/READY_FROZ": "game/ready-meals",
  "productRange/SOUPS": "game/amestecuri-legume-pentru-supe",
  "productRange/SPINACH": "game/spanac",
  "productRange/STEAM_CAN": "game/conserve-vapeur",
  "productRange/STEAM_FRZ": "game/legume-vapeur",
  "productRange/STEAM_MIX": "game/amestecuri-congelate-Vapeur",
  "productRange/STUZZICHIA": "game/-",
  "productRange/TOUCHE": "game/miniconserve",
  "productRange/TRAIT_SAL": "game/legume-pentru-salata",
  "productRange/TUS_RECETA ": "game/retetele-tale",
  "productRange/VEG_TO_FRY": "game/legume-pentru-tigaie",
  "productRange/VEGGIE": "game/amestecuri-cu-orez",
  "productRange/FRZ_JUSTEA": "game/monolegume-congelate",
  "productRange/SALABIS": "game",
  "productRange/BON_SENGAG": "game",
  "productRange/CROUSTIS": "game",
  "season": "anotimpuri",
  "season/1": "anotimpuri/vara",
  "season/2": "anotimpuri/toamna",
  "season/3": "anotimpuri/iarna",
  "season/4": "anotimpuri/primavara",
  "season/5": "anotimpuri",
  "technologie": "tehnologie",
  "technologie/AC01": "tehnologie/conserva",
  "technologie/AD01": "tehnologie/congelat",
  "technologie/AG01": "tehnologie/proaspat",
  "technologie/AT01": "tehnologie/catering",
  "recipeDish": "tip-de-reteta",
  "recipeDish/ACC": "tip-de-reteta",
  "recipeDish/APE": "tip-de-reteta/aperitiv",
  "recipeDish/DES": "tip-de-reteta/desert",
  "recipeDish/ENT": "tip-de-reteta/fel-principal",
  "recipeDish/PLAT": "tip-de-reteta/dish",
  "recipeDish/SAL": "tip-de-reteta/salata",
  "recipeDish/SNA": "tip-de-reteta/snack",
  "recipeDish/PDE": "tip-de-reteta/mic-dejun",
  "recipeDish/DEJ": "tip-de-reteta/pranz",
  "recipeDish/TRA": "tip-de-reteta/traditional",
  "recipeDish/GOU": "tip-de-reteta/mancare-gourmet",
  "recipeDish/ETH": "tip-de-reteta/-",
  "recipeDish/FCH": "tip-de-reteta/pentru-copii",
  "recipeDish/SOU": "tip-de-reteta/supe",
  "pred-recipeTimingCook-facet": "coacere",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "coacere/0-15-minute",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "coacere/15-30-minute",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "coacere/30-45-minute",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "coacere/45-minute",
  "pred-recipeTimingPreparation-facet": "preparare",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "preparare/0-15-minute",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "preparare/15-30-minute",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "preparare/30-45-minute",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "preparare/45-minute",
  "pred-recipeCost-Facet": "costuri",
  "pred-recipeCost-Facet/petit": "costuri/ieftin",
  "pred-recipeCost-Facet/moyen": "costuri/mediu",
  "pred-recipeCost-Facet/grand": "costuri/scump",
  "recipeDifficulty": "dificultate-de-preparare",
  "recipeDifficulty/1": "dificultate-de-preparare/usor",
  "recipeDifficulty/2": "dificultate-de-preparare/mediu",
  "recipeDifficulty/3": "dificultate-de-preparare/dificil",
  "recipeDishNumber": "persoane",
  "recipeDishNumber/1": "persoane/1",
  "recipeDishNumber/2": "persoane/2",
  "recipeDishNumber/3": "persoane/3",
  "recipeDishNumber/4": "persoane/4",
  "recipeDishNumber/5": "persoane/5",
  "recipeDishNumber/6": "persoane/6",
  "recipeDishNumber/7": "persoane/7",
  "recipeDishNumber/8": "persoane/8",
  "productTheme": "produse-dupa-tema",
  "productTheme/ACC": "produse-dupa-tema/garnitura",
  "productTheme/BEA": "produse-dupa-tema/fasole",
  "productTheme/BIS": "produse-dupa-tema/fasole-in-sos",
  "productTheme/BIO": "produse-dupa-tema/bio",
  "productTheme/CAN": "produse-dupa-tema/legume-la-conserva",
  "productTheme/CER": "produse-dupa-tema/cereali",
  "productTheme/CLS": "produse-dupa-tema/clasice",
  "productTheme/DLE": "produse-dupa-tema/legume--",
  "productTheme/EDR": "produse-dupa-tema/mini-conserve",
  "productTheme/ENT": "produse-dupa-tema/-",
  "productTheme/FRZ": "produse-dupa-tema/congelate",
  "productTheme/FSD": "produse-dupa-tema/pentru-salate",
  "productTheme/FSH": "produse-dupa-tema/-",
  "productTheme/ING": "produse-dupa-tema/ingrediente-pentru-retetele-mele",
  "productTheme/JAR": "produse-dupa-tema/legume-in-borcan",
  "productTheme/LBW": "produse-dupa-tema/lunch-bowl",
  "productTheme/LDF": "produse-dupa-tema/legume-in-cuptor",
  "productTheme/LEG": "produse-dupa-tema/-",
  "productTheme/LGO": "produse-dupa-tema/-",
  "productTheme/LGR": "produse-dupa-tema/legume-grill",
  "productTheme/LGS": "produse-dupa-tema/legume-pentru-supa",
  "productTheme/MAI": "produse-dupa-tema/-",
  "productTheme/MUS": "produse-dupa-tema/ciuperci",
  "productTheme/NEW": "produse-dupa-tema/produse-noi",
  "productTheme/PDH": "produse-dupa-tema/preparate-din-legume-uscate",
  "productTheme/PDL": "produse-dupa-tema/cos-de-legume",
  "productTheme/PHR": "produse-dupa-tema/paste",
  "productTheme/PLP": "produse-dupa-tema/fel-principal",
  "productTheme/RAL": "produse-dupa-tema/orez-din-legume",
  "productTheme/RDM": "produse-dupa-tema/-",
  "productTheme/SAL": "produse-dupa-tema/pentru-salate",
  "productTheme/SDB": "produse-dupa-tema/-",
  "productTheme/SNK": "produse-dupa-tema/gustari",
  "productTheme/SUP": "produse-dupa-tema/supe",
  "productTheme/TEX": "produse-dupa-tema/texas-mix",
  "productTheme/VGP": "produse-dupa-tema/proteine-vegetale",
  "recipeTheme": "tema-retetelor",
  "recipeTheme/01": "tema-retetelor/retete-festive",
  "recipeTheme/02": "tema-retetelor/aperitiv",
  "recipeTheme/03": "tema-retetelor/salate-si-gustari",
  "recipeTheme/04": "tema-retetelor/supe-şi-gaspachos",
  "recipeTheme/05": "tema-retetelor/quiche-tort-si-garnituri",
  "recipeTheme/06": "tema-retetelor/special-pentru-copii",
  "recipeTheme/07": "tema-retetelor/deserturi",
  "recipeTheme/08": "tema-retetelor/vegetariene",
  "recipeTheme/09": "tema-retetelor/garnituri",
  "recipeTheme/10": "tema-retetelor/-",
  "recipeTheme/11": "tema-retetelor/-",
  "recipeTheme/12": "tema-retetelor/salate-si-pregatite-la-gratar",
  "recipeTheme/13": "tema-retetelor/-",
  "recipeTheme/14": "tema-retetelor/fel-principal",
  "recipeTheme/15": "tema-retetelor/deserturi-si-patiserie",
  "recipeTheme/16": "tema-retetelor/aperitive-si-supe",
  "recipeTheme/17": "tema-retetelor/salate-",
  "recipeTheme/18": "tema-retetelor/boluri",
  "recipeTheme/19": "tema-retetelor/supe",
  "recipeTheme/20": "tema-retetelor/gustari",
  "recipeTheme/21": "tema-retetelor/sos",
  "recipeTheme/22": "tema-retetelor/feluri-principale",
  "recipeTheme/23": "tema-retetelor/alte-preparate",
  "recipeTheme/24": "tema-retetelor/preparate-la-cuptor",
  "recipeTheme/25": "tema-retetelor/mexican",
  "recipeTheme/26": "tema-retetelor/-",
  "recipeTheme/27": "tema-retetelor/ziua-fara-carne",
  "recipeTheme/28": "tema-retetelor/slab-in-carbohidrati",
  "recipeTheme/33": "tema-retetelor/pe-baza-de-linte",
  "recipeTheme/34": "tema-retetelor/pe-baza-de-conopida",
  "recipeTheme/35": "tema-retetelor/pe-baza-de-cartofi",
  "recipeTheme/36": "tema-retetelor/pe-baza-de-morcovi",
  "recipeTheme/37": "tema-retetelor/pe-baza-de-spanac",
  "recipeTheme/38": "tema-retetelor/pe-baza-de-ardei",
  "recipeTheme/39": "tema-retetelor/pe-baza-de-ciuperci",
  "recipeTheme/40": "tema-retetelor/pe-baza-de-fasole-verde-plata",
  "recipeTheme/41": "tema-retetelor/pe-baza-de-porumb",
  "recipeTheme/42": "tema-retetelor/-",
  "recipeTheme/43": "tema-retetelor/pe-baza-de-fasole-rosie",
  "recipeTheme/44": "tema-retetelor/pe-baza-de-fasole-flageolet",
  "recipeTheme/45": "tema-retetelor/pe-baza-de-naut",
  "recipeTheme/46": "tema-retetelor/pe-baza-de-broccoli",
  "pred-particularite": "particularitati",
  "pred-particularite/Sans%20conservateur": "obiceiuri-culinare/fara-conservanti",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "obiceiuri-culinare",
  "pred-particularite/Sans%20colorant": "obiceiuri-culinare/fara-coloranti",
  "pred-particularite/Sans%20sucre%20ajout%E9": "obiceiuri-culinare/fara-zahar-adaugat",
  "pred-particularite/Sans%20sel%20ajout%E9": "obiceiuri-culinare/fara-sare-adaugata",
  "pred-particularite/Sans%20additif": "obiceiuri-culinare/fara-aditivi",
  "pred-particularite/": "obiceiuri-culinare",
  "pred-particularite/Sans%20lactose": "obiceiuri-culinare/fara-lactoza",
  "pred-particularite/Sans%20gluten": "obiceiuri-culinare/fara-gluten",
  "pred-particularite/V%E9g%E9tarien": "obiceiuri-culinare/vegan",
  "pred-particularite/V%E9g%E9talien": "obiceiuri-culinare/vegetarian",
  "pred-particularite/Sans%20sulfite": "obiceiuri-culinare/fara-sulfiti",
  "pred-particularite/A%20la%20vapeur": "obiceiuri-culinare/pregatite-la-aburi",
  "pred-particularite/Sans%20condiment": "obiceiuri-culinare/fara-condimente",
  "cultureType": "tip-de-cultura",
  "cultureType/Bio": "tip-de-cultura/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "tip-de-cultura/fara-reziduri-de-pesticide",
  "cultureType/Sans%20OGM": "tip-de-cultura/fara-OMG",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "particularitati/vegetarian",
  "pred-particularite/recipeVeggie": "particularitati/vegan",
  "pred-particularite/recipeGlutenfree": "particularitati/fara-gluten",
  "pred-particularite/recipeLactosefree": "particularitati/fara-lactoza",
  "cultureOrigin": "originea-culturii",
  "cultureOrigin/31": "originea-culturii/Azerbaijan",
  "cultureOrigin/32": "originea-culturii/Argentina",
  "cultureOrigin/36": "originea-culturii/Australia",
  "cultureOrigin/40": "originea-culturii/Austria",
  "cultureOrigin/51": "originea-culturii/Armenia",
  "cultureOrigin/56": "originea-culturii/Belgia",
  "cultureOrigin/68": "originea-culturii/Bolivia",
  "cultureOrigin/70": "originea-culturii/Bosnia-si-Hertegovina",
  "cultureOrigin/76": "originea-culturii/Brazilia",
  "cultureOrigin/97": "originea-culturii/Uniunea-Europeana",
  "cultureOrigin/100": "originea-culturii/Bulgaria",
  "cultureOrigin/104": "originea-culturii/Birmania",
  "cultureOrigin/120": "originea-culturii/Camerun",
  "cultureOrigin/124": "originea-culturii/Canada",
  "cultureOrigin/152": "originea-culturii/chile",
  "cultureOrigin/156": "originea-culturii/China",
  "cultureOrigin/188": "originea-culturii/costa-rica",
  "cultureOrigin/191": "originea-culturii/Croaţia",
  "cultureOrigin/196": "originea-culturii/cipru",
  "cultureOrigin/203": "originea-culturii/Republica-Ceha",
  "cultureOrigin/208": "originea-culturii/Danemarca",
  "cultureOrigin/231": "originea-culturii/Etiopia",
  "cultureOrigin/233": "originea-culturii/Estonia",
  "cultureOrigin/246": "originea-culturii/Finlanda",
  "cultureOrigin/250": "originea-culturii/Franţa",
  "cultureOrigin/258": "originea-culturii/Polinezia-Franceza",
  "cultureOrigin/276": "originea-culturii/Germania",
  "cultureOrigin/300": "originea-culturii/Grecia",
  "cultureOrigin/320": "originea-culturii/Guatemala",
  "cultureOrigin/344": "originea-culturii/hong-kong",
  "cultureOrigin/348": "originea-culturii/Ungaria",
  "cultureOrigin/352": "originea-culturii/Islanda",
  "cultureOrigin/356": "originea-culturii/indii",
  "cultureOrigin/360": "originea-culturii/Indonezia",
  "cultureOrigin/372": "originea-culturii/Irlanda",
  "cultureOrigin/376": "originea-culturii/israel",
  "cultureOrigin/380": "originea-culturii/Italia",
  "cultureOrigin/398": "originea-culturii/Kazahstan",
  "cultureOrigin/404": "originea-culturii/kenia",
  "cultureOrigin/414": "originea-culturii/Kuweit",
  "cultureOrigin/417": "originea-culturii/Kargazstan",
  "cultureOrigin/422": "originea-culturii/Liban",
  "cultureOrigin/428": "originea-culturii/Letonia",
  "cultureOrigin/440": "originea-culturii/Lituania",
  "cultureOrigin/442": "originea-culturii/Luxemburg",
  "cultureOrigin/450": "originea-culturii/Madagascar",
  "cultureOrigin/470": "originea-culturii/malţ",
  "cultureOrigin/480": "originea-culturii/mauritius",
  "cultureOrigin/484": "originea-culturii/Mexic",
  "cultureOrigin/498": "originea-culturii/moldova",
  "cultureOrigin/499": "originea-culturii/muntenegru",
  "cultureOrigin/504": "originea-culturii/Maroc",
  "cultureOrigin/528": "originea-culturii/Olanda",
  "cultureOrigin/548": "originea-culturii/vanuatu",
  "cultureOrigin/578": "originea-culturii/Norvegia",
  "cultureOrigin/586": "originea-culturii/Pakistan",
  "cultureOrigin/604": "originea-culturii/Peru",
  "cultureOrigin/616": "originea-culturii/Polonia",
  "cultureOrigin/620": "originea-culturii/Portugalia",
  "cultureOrigin/634": "originea-culturii/Quatar",
  "cultureOrigin/642": "originea-culturii/Romania",
  "cultureOrigin/643": "originea-culturii/Rusia",
  "cultureOrigin/703": "originea-culturii/Slovacia",
  "cultureOrigin/704": "originea-culturii/Vietnam",
  "cultureOrigin/705": "originea-culturii/Slovenia",
  "cultureOrigin/724": "originea-culturii/Spania",
  "cultureOrigin/752": "originea-culturii/Suedia",
  "cultureOrigin/756": "originea-culturii/Elveţia",
  "cultureOrigin/764": "originea-culturii/Tailanda",
  "cultureOrigin/784": "originea-culturii/Emiratele-Arabe-Unite",
  "cultureOrigin/792": "originea-culturii/Turcia",
  "cultureOrigin/795": "originea-culturii/Turkmenistan",
  "cultureOrigin/804": "originea-culturii/Ucraina",
  "cultureOrigin/818": "originea-culturii/Egipt",
  "cultureOrigin/826": "originea-culturii/Regatul-Unit",
  "cultureOrigin/834": "originea-culturii/Tanzania",
  "cultureOrigin/840": "originea-culturii/Statele-Unite",
  "cultureOrigin/999": "originea-culturii/Export",
  "cultureOrigin/NON_EU": "originea-culturii/NON-UE",
  "cultureOrigin/UE": "originea-culturii/UE",
  "cultureOrigin/XXX": "originea-culturii"
};
